import { SortArrow } from "../../../../assets/icons/SortArrow";
import { SortArrows } from "../../../../assets/icons/SortArrows";
import {
  SORT_CALCUL_CREATED_AT_ASC,
  SORT_CALCUL_CREATED_AT_DESC,
  SORT_CALCUL_FAMILY_PRODUCT_ASC,
  SORT_CALCUL_FAMILY_PRODUCT_DESC,
  SORT_CALCUL_INDICATOR_AT_ASC,
  SORT_CALCUL_INDICATOR_AT_DESC,
  SORT_CALCUL_MODIFIED_AT_ASC,
  SORT_CALCUL_MODIFIED_AT_DESC,
  SORT_CALCUL_NAME_ASC,
  SORT_CALCUL_NAME_DESC,
  SORT_CALCUL_PROJECT_NAME_ASC,
  SORT_CALCUL_PROJECT_NAME_DESC,
  SORT_CALCUL_STATUS_ASC,
  SORT_CALCUL_STATUS_DESC,
} from "../../../../common/constants/sort";

export const CalculTableHeaders = ({
  calculsColumns,
  handleSort,
  sort,
  isArchivesFolder = false,
}) => {
  const columns = [];

  (calculsColumns || []).forEach((column) => {
    if (!column.active) return;
    if (isArchivesFolder && column.value === "folders") return;
    switch (column.value) {
      case "name":
        columns.push(
          <th
            className="sortable pl-1"
            onClick={() =>
              handleSort(SORT_CALCUL_NAME_ASC, SORT_CALCUL_NAME_DESC)
            }
            key={`column-${column.value}`}
          >
            <div>
              <span className="column-title">Nom du calcul</span>
              <div className="sort-container">
                {sort === SORT_CALCUL_NAME_ASC ||
                sort === SORT_CALCUL_NAME_DESC ? (
                  <SortArrow
                    size={16}
                    className="active"
                    direction={sort === SORT_CALCUL_NAME_ASC ? "up" : "down"}
                  />
                ) : (
                  <SortArrows size={16} className="disabled" />
                )}
              </div>
            </div>
          </th>,
        );
        break;
      case "status":
        columns.push(
          <th
            className="px-1"
            onClick={() =>
              handleSort(SORT_CALCUL_STATUS_ASC, SORT_CALCUL_STATUS_DESC)
            }
            key={`column-${column.value}`}
          >
            <div>
              <span className="column-title">Statut</span>
              <div className="sort-container">
                {sort === SORT_CALCUL_STATUS_ASC ||
                sort === SORT_CALCUL_STATUS_DESC ? (
                  <SortArrow
                    size={16}
                    className="active"
                    direction={sort === SORT_CALCUL_STATUS_ASC ? "up" : "down"}
                  />
                ) : (
                  <SortArrows size={16} className="disabled" />
                )}
              </div>
            </div>
          </th>,
        );
        break;
      case "result":
        columns.push(
          <th
            className="sortable pl-1"
            onClick={() =>
              handleSort(
                SORT_CALCUL_INDICATOR_AT_ASC,
                SORT_CALCUL_INDICATOR_AT_DESC,
              )
            }
            key={`column-${column.value}`}
          >
            <div>
              <span className="column-title">Résultat</span>
              <div className="sort-container">
                {sort === SORT_CALCUL_INDICATOR_AT_ASC ||
                sort === SORT_CALCUL_INDICATOR_AT_DESC ? (
                  <SortArrow
                    size={16}
                    className="active"
                    direction={
                      sort === SORT_CALCUL_INDICATOR_AT_ASC ? "up" : "down"
                    }
                  />
                ) : (
                  <SortArrows size={16} className="disabled" />
                )}
              </div>
            </div>
          </th>,
        );
        break;
      case "folders":
        columns.push(
          <th className="px-1" key={`column-${column.value}`}>
            <span className="column-title">Dossiers</span>
          </th>,
        );
        break;
      case "projectName":
        columns.push(
          <th
            className="sortable pl-1"
            onClick={() =>
              handleSort(
                SORT_CALCUL_PROJECT_NAME_ASC,
                SORT_CALCUL_PROJECT_NAME_DESC,
              )
            }
            key={`column-${column.value}`}
          >
            <div>
              <span className="column-title">Nom du projet</span>
              <div className="sort-container">
                {sort === SORT_CALCUL_PROJECT_NAME_ASC ||
                sort === SORT_CALCUL_PROJECT_NAME_DESC ? (
                  <SortArrow
                    size={16}
                    className="active"
                    direction={
                      sort === SORT_CALCUL_PROJECT_NAME_ASC ? "up" : "down"
                    }
                  />
                ) : (
                  <SortArrows size={16} className="disabled" />
                )}
              </div>
            </div>
          </th>,
        );
        break;
      case "productFamily":
        columns.push(
          <th
            className="sortable pl-1"
            onClick={() =>
              handleSort(
                SORT_CALCUL_FAMILY_PRODUCT_ASC,
                SORT_CALCUL_FAMILY_PRODUCT_DESC,
              )
            }
            key={`column-${column.value}`}
          >
            <div>
              <span className="column-title">Famille de produit</span>
              <div className="sort-container">
                {sort === SORT_CALCUL_FAMILY_PRODUCT_ASC ||
                sort === SORT_CALCUL_FAMILY_PRODUCT_DESC ? (
                  <SortArrow
                    size={16}
                    className="active"
                    direction={
                      sort === SORT_CALCUL_FAMILY_PRODUCT_ASC ? "up" : "down"
                    }
                  />
                ) : (
                  <SortArrows size={16} className="disabled" />
                )}
              </div>
            </div>
          </th>,
        );
        break;
      case "version":
        columns.push(
          <th className="px-1" key={`column-${column.value}`}>
            <span className="column-title">Version</span>
          </th>,
        );
        break;
      case "createdAt":
        columns.push(
          <th
            className="sortable pl-1"
            onClick={() =>
              handleSort(
                SORT_CALCUL_CREATED_AT_ASC,
                SORT_CALCUL_CREATED_AT_DESC,
              )
            }
            key={`column-${column.value}`}
          >
            <div>
              <span className="column-title">Création</span>
              <div className="sort-container">
                {sort === SORT_CALCUL_CREATED_AT_ASC ||
                sort === SORT_CALCUL_CREATED_AT_DESC ? (
                  <SortArrow
                    size={16}
                    className="active"
                    direction={
                      sort === SORT_CALCUL_CREATED_AT_ASC ? "up" : "down"
                    }
                  />
                ) : (
                  <SortArrows size={16} className="disabled" />
                )}
              </div>
            </div>
          </th>,
        );
        break;
      case "updatedAt":
        columns.push(
          <th
            className="sortable pl-1"
            onClick={() =>
              handleSort(
                SORT_CALCUL_MODIFIED_AT_ASC,
                SORT_CALCUL_MODIFIED_AT_DESC,
              )
            }
            key={`column-${column.value}`}
          >
            <div>
              <span className="column-title">Modification</span>
              <div className="sort-container">
                {sort === SORT_CALCUL_MODIFIED_AT_ASC ||
                sort === SORT_CALCUL_MODIFIED_AT_DESC ? (
                  <SortArrow
                    size={16}
                    className="active"
                    direction={
                      sort === SORT_CALCUL_MODIFIED_AT_ASC ? "up" : "down"
                    }
                  />
                ) : (
                  <SortArrows size={16} className="disabled" />
                )}
              </div>
            </div>
          </th>,
        );
        break;
      default:
        break;
    }
  });

  return columns;
};
